






















































  import { Button, Form, Field,Picker,Toast,Popup,Tab, Tabs, Sticky } from "vant";
  import position from './components/position.vue'
  import fund from './components/fund.vue'
  import deal from './components/deal.vue'
  import entrust from './components/entrust.vue'
  export default {
    components: {
      [Button.name]: Button,
      [Form.name]: Form,
      [Field.name]: Field,
      [Picker.name]: Picker,
      [Popup.name]: Popup,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Sticky.name]: Sticky,
      position,
      fund,
      deal,
      entrust
    },
    props:{
      // 按组查-0 按账户-1
      queryMode:{
        type:Number
      },
      groupObj:{
        type:Object
      }
    },
    data() {
      return {
        groupColumns: ['按组查', '按账户'],
        accountColumns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
        overlayShow:false,
        sonOverlayShow:false,
        activeTab:0,
        curGroup:{
            value:"按组查",
            index:0
        },
        curSelect:'',
        queryParem:{
            aroupType:0,
            type:0,
            account:''
        }
      };
    },
    created(){
        // (this as any).getSelect()
    },
    computed:{
        columnsOption(){
          if((this as any).accountColumns && (this as any).accountColumns.length > 0){
            if((this as any).curGroup.index === 0){
              return (this as any).accountColumns.map(item => {
                return item.group_name
              })
            }else if((this as any).curGroup.index === 1){
              return (this as any).accountColumns.map(item => {
                return item.futures_login_id
              })
            }
          }

        },
      isSecurities(){
          return (this as any).queryMode == 0 && (this as any).groupObj.text == "证券账户组"
      }
    },
    watch:{
      queryMode(newV,oldV){
        (this as any).queryModeOperate();
      },
      groupObj(newV,oldV){
        (this as any).groupObjOperate();
      }
    },
    methods: {
      changeActiveTab(){
        setTimeout(()=>{
          (this as any).$emit("changeActiveTab");
        })
      },
        getSelect(){
            if((this as any).curGroup.index === 0){
                (this as any).$apis
                .getGroupList({show_account:1})
                .then(respond => {
                  let res = respond.data;
                  
                    if(res[0]){
                        (this as any).accountColumns = res;
                        (this as any).curSelect = res[0].group_name || '无';
                        (this as any).queryParem.account = res[0].account_list.join();
                        (this as any).queryParem.type = res[0].type
                    }else{
                        (this as any).curSelect = '无';
                        (this as any).accountColumns = [];
                    }
                })
                .catch(e => {
                    
                });
            }else if((this as any).curGroup.index === 1){
                (this as any).$apis
                .getAccountList()
                .then(respond => {
                  let res = respond.data;
                    if(res[0]){
                        (this as any).accountColumns = res;
                        (this as any).curSelect = res[0].futures_login_id;
                        (this as any).queryParem.account = res[0].futures_login_id;
                        (this as any).queryParem.type = res[0].group_id
                    }else{
                        (this as any).curSelect = '无';
                        (this as any).accountColumns = [];
                    }

                })
                .catch(e => {
                    
                });
            }

        },
        onConfirm(value, index) {
            (this as any).curGroup = { value, index };

            (this as any).queryParem.aroupType = index;
            (this as any).getSelect();
            (this as any).overlayShow = false;
        },
        onChange(picker, value, index) {
            
        },
        onCancel() {
            
            (this as any).overlayShow = false
        },
        onSonConfirm(value, index) {
            
            if((this as any).curGroup.index === 0){
                (this as any).queryParem.type = (this as any).accountColumns[index].type;
                (this as any).queryParem.account = (this as any).accountColumns[index].account_list.join();
                (this as any).curSelect = (this as any).accountColumns[index].group_name || '无';
                
            }else if((this as any).curGroup.index === 1){
                (this as any).queryParem.account = (this as any).accountColumns[index].futures_login_id;
                (this as any).queryParem.type = (this as any).accountColumns[index].group_id;
                (this as any).curSelect = (this as any).accountColumns[index].futures_login_id || '无';
            }

            (this as any).sonOverlayShow = false;

        },
        onSonChange(picker, value, index) {
            
        },
        onSonCancel() {
            
            (this as any).sonOverlayShow = false
        },
      queryModeOperate(){
        switch ((this as any).queryMode) {
          case 0:
            (this as any).curGroup.value = "按组查";
            (this as any).curGroup.index = 0;
            break;
          case 1:
            (this as any).curGroup.value = "按账户";
            (this as any).curGroup.index = 1;
            break;
        }

        (this as any).curSelect = '';
        (this as any).queryParem.aroupType = 0;
        (this as any).queryParem.type = 0;
        (this as any).queryParem.account = '';
      },
      groupObjOperate(){
        switch ((this as any).queryMode) {
          // 组查
          case 0:
            (this as any).curSelect = (this as any).groupObj.text;
			if((this as any).groupObj.list){
				(this as any).queryParem.account = (this as any).groupObj.list.join();
			}
            (this as any).queryParem.type = (this as any).groupObj.id;
            break;
          // 账户查
          case 1:
            (this as any).curSelect = (this as any).groupObj.name;
            (this as any).queryParem.account = (this as any).groupObj.name;
            (this as any).queryParem.type = (this as any).groupObj.id;
            break;
        }
      },
      notifyNewOrder(){
          let tabRefNameArr = ['position','entrust','deal','fund'];
          let tabRefName = tabRefNameArr[(this as any).activeTab];
          (this as any).$refs[tabRefName].notifyNewOrder();
      }
    }
  };
  